
      const isLegacyAuthCallback = /^\/auth\/callback\/?$/.test(
        window.location.pathname
      );

      if (isLegacyAuthCallback) {
        const targetUrl = `/auth-callback.html${window.location.search}${window.location.hash}`;
        window.location.replace(targetUrl);
      } else {
        import('/src/index.tsx');
      }
    